<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="仓库名称">
              <a-input placeholder="请输入仓库名称搜索" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择" default-value="" v-model="queryParam.status">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="active">启用</a-select-option>
                <a-select-option value="deleted">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetTableSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <a-button type="default" icon="reload" @click="reloadTable">刷新</a-button>
    </div>

    <s-table
      size="default"
      ref="table"
      rowKey="id"
      :pageSize=20
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="status" slot-scope="text, record">
        <a-switch checkedChildren="启用" unCheckedChildren="禁用" defaultChecked v-if="record.status == 'active'" @change="statusChange($event, record)"/>
        <a-switch checkedChildren="启用" unCheckedChildren="禁用" v-else  @change="statusChange($event, record)"/>
      </span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm placement="topLeft" title="确定要删除此仓库吗?删除后无法恢复！" @confirm="deleteConfirm(record.id)" okText="确定" cancelText="取消">
                <a href="#">删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <a-modal
      :title="title"
      style="top: 20px;"
      :width="800"
      v-model="visible"
      @ok="editFormSubmit($event,selectrow)"
    >
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="仓库编号"
        >
          <a-input
            placeholder="仓库编号"
            v-model="selectrow.locationNo"
            autocomplete="false"
          />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="仓库名称"
        >
          <a-input
            placeholder="仓库名称"
            v-model="selectrow.name"
            autocomplete="false"
          />
        </a-form-item>

      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import { getStoreList, editStore, addStore, deleteStore } from '@/api/store'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  name: 'SettingsStoreList',
  components: {
    STable
  },
  data () {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: null,
      isEditForm: false,
      title: '新增',
      selectrow: {},

      // 查询参数
      queryParam: {
        name: '',
        status: ''
      },
      // 表头
      columns: [
        {
          title: '仓库编号',
          dataIndex: 'locationNo'
        },
        {
          title: '仓库名称',
          dataIndex: 'name'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getStoreList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      }
    }
  },
  created () {

  },
  methods: {
    handleEdit (record) {
      this.selectrow = Object.assign({}, record)
      this.title = '编辑'
      this.isEditForm = true
      this.visible = true
    },
    handleAdd () {
      this.selectrow = {
        name: '',
        locationNo: ''
      }
      this.title = '新增'
      this.isEditForm = false
      this.visible = true
    },
    // 修改表单提交
    editFormSubmit (e) {
      e.preventDefault()
      const data = this.selectrow
      if (this.isEditForm) {
        editStore(data).then(res => {
          if (res.status !== CODE_FAIL) {
            this.visible = false
            this.$message.success('修改成功')
            this.reloadTable()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        addStore(data).then(res => {
          if (res.status !== CODE_FAIL) {
            this.visible = false
            this.$message.success('新增成功')
            this.reloadTable()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    resetTableSearch () {
      this.queryParam = {
        name: '',
        status: ''
      }
      this.reloadTable()
    },
    statusChange (event, record) {
      const data = record
      data.status = event === true ? 'active' : 'deleted'
      editStore(data).then(res => {
        this.$message.success('修改成功')
      }).catch(err => {
        this.$message.error(((err.response || {}).data || {}).message || '请求出现错误，请稍后再试')
      })
    },
    deleteConfirm (id) {
      deleteStore({ id: id }).then((res) => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
          this.reloadTable()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
